document.addEventListener("DOMContentLoaded", function () {
  const bar = document.querySelector(".js-mobile-scroll-search");
  if (!bar) return;

  let last = 0;
  let barHeight = bar.offsetHeight; // save real height

  window.addEventListener("scroll", function () {
    const current = window.pageYOffset;

    if (current > last && current > 50) {
      // Scroll DOWN → hide and collapse space
      bar.style.transform = "translateY(-100%)";
      bar.style.opacity = "0";
      bar.style.pointerEvents = "none";
      bar.style.height = "0px";
      bar.style.padding = "0px";
      bar.style.overflow = "hidden";
    } else {
      // Scroll UP → show and restore space
      bar.style.transform = "translateY(0)";
      bar.style.opacity = "1";
      bar.style.pointerEvents = "auto";
      bar.style.height = barHeight + "px";
      bar.style.padding = "";
      bar.style.overflow = "";
    }

    last = current <= 0 ? 0 : current;
  });
});
